// #region imports

// --- Angular
import { Component, Input } from '@angular/core';

// #endregion

@Component({
  selector: 'hs-badge',
  templateUrl: './badge.component.html',
  styleUrls: ['./badge.component.scss']
})
export class BadgeComponent {

  @Input() text: string = '';
  @Input() iconPack: 'font-awesome' | 'material' = 'material';
  @Input() icon: string = '';
  @Input() status: string = '';
}
